export enum UIActions {
  UI_SIDEBAR_TOOGLE = '[UI] Sidebar Toggle',
  UI_SIDEBAR_SET_STATE = '[UI] Sidebar Set State',
  UI_SET_CURRENT_SCROLL_TOP = '[UI] Set Current Scroll Top',
  UI_HIDE_SIDEBAR = '[UI] Hide Sidebar',
  UI_SHOW_SIDEBAR = '[UI] Show Sidebar',
}
